import { FlaskConical } from "lucide-react";

/**
 * Selo BETA — recurso liberado e funcionando, mas ainda em ajuste.
 *
 * Existe pra ser honesto com o lojista: ele está usando algo novo, que pode
 * mudar de comportamento nas próximas semanas. Sem esse aviso, uma mudança de
 * regra depois parece bug; com ele, parece o que é.
 *
 * `explicacao` acompanha o selo num bloco abaixo do título. Cada tela passa a
 * sua, porque "o que ainda pode mudar" é diferente em cada recurso — um texto
 * genérico não ajudaria ninguém.
 */
export function SeloBeta({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-violet-500/15 text-violet-600 dark:text-violet-400 border border-violet-500/30 align-middle ${className}`}
    >
      <FlaskConical className="w-3 h-3" />
      Beta
    </span>
  );
}

export function AvisoBeta({ children }) {
  return (
    <div className="flex gap-2.5 rounded-xl border border-violet-500/25 bg-violet-500/5 px-4 py-3">
      <FlaskConical className="w-4 h-4 text-violet-600 dark:text-violet-400 flex-shrink-0 mt-0.5" />
      <p className="text-[13px] leading-snug text-muted-foreground">{children}</p>
    </div>
  );
}

export default SeloBeta;
